import { useState } from "react";
import JoinMeetingCheck, {
  type JoinMeetingCheckValues,
} from "../../components/public/join-meeting/JoinMeetingCheck";
import JoinMeetingOTP from "../../components/public/join-meeting/JoinMeetingOTP";
import JoinMeetingProfile from "../../components/public/join-meeting/JoinMeetingProfile";
// import { getPublicPrejoinCasesApi } from "../../api/publicMeetingJoinApi";

type Step = "Join" | "OTP" | "Profile";

const steps: Array<{ key: Step; label: string }> = [
  { key: "Join", label: "Details" },
  { key: "OTP", label: "Verify" },
  { key: "Profile", label: "Profile" },
];

const JoinMeeting = () => {
  const [step, setStep] = useState<Step>("Join");
  const activeIndex = steps.findIndex((item) => item.key === step);
  const [meetingDetails, setMeetingDetails] = useState<JoinMeetingCheckValues>({
    meetingId: "",
    mobile: "",
    caseNumber: "",
  });

  // const handleCheck = async () => {
  //   const respcases = await getPublicPrejoinCasesApi({
  //     roomId: "6a13f223d6f6e7956f096bc1",
  //   });
  //   console.log("respcases", respcases);
  // };
  // useEffect(() => {
  //   handleCheck();
  // }, []);

  return (
    <div className="w-full max-w-md mx-auto py-6">
      <div className="text-center mb-6">
        <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
          <img src="logo.png" alt="NyayNet Logo" className="w-10 h-10" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-1">Join Meeting</h1>
        <p className="text-sm text-blue-200">
          {step === "Join" && "Enter your meeting and case details to continue"}
          {step === "OTP" && "Verify your mobile number"}
          {step === "Profile" && "Tell us who is joining"}
        </p>
      </div>

      {/* Stepper */}
      <div className="mb-6 flex items-center justify-center gap-2">
        {steps.map((item, index) => (
          <div key={item.key} className="flex items-center gap-2">
            <div className="flex flex-col items-center gap-1">
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-full border text-sm font-bold transition ${
                  index <= activeIndex
                    ? "border-white bg-white text-slate-900"
                    : "border-white/30 bg-white/10 text-blue-200"
                }`}
              >
                {index + 1}
              </div>
              <span
                className={`text-[11px] ${index <= activeIndex ? "text-white" : "text-blue-200"}`}
              >
                {item.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`mb-4 h-0.5 w-10 rounded-full transition ${
                  index < activeIndex ? "bg-white" : "bg-white/25"
                }`}
              />
            )}
          </div>
        ))}
      </div>

      {/* Card */}
      <div className="rounded-2xl border border-white/15 bg-white/10 p-5 shadow-2xl backdrop-blur-md sm:p-6">
        {step === "Join" && (
          <JoinMeetingCheck
            onNext={(item) => {
              setStep("OTP");
              setMeetingDetails(item);
            }}
          />
        )}
        {step === "OTP" && (
          <JoinMeetingOTP
            meetingDetails={meetingDetails}
            onNext={() => setStep("Profile")}
            onBack={() => setStep("Join")}
          />
        )}
        {step === "Profile" && (
          <JoinMeetingProfile
            meetingDetails={meetingDetails}
            onBack={() => setStep("OTP")}
          />
        )}
      </div>
    </div>
  );
};

export default JoinMeeting;
